export default __webpack_public_path__ + "static/markus-236616db6b0a147d0b03cd8d3c861f6f.png";